// extracted by mini-css-extract-plugin
export default {"paddingRight":"style_paddingRight__TgK+p","hover":"style_hover__xEsc5","link":"style_link__fdCME","editWrapper":"style_editWrapper__Ms4sc","close":"style_close__wReQF"};